import { useEffect, useState } from 'react';
import AttendanceLocationsPanel from '../components/dashboard/AttendanceLocationsPanel';
import AttendanceReportsBoard from '../components/dashboard/AttendanceReportsBoard';

const MOBILE_BREAKPOINT = 960;

function getInitialCompactMode() {
  if (typeof window === 'undefined') return false;
  return window.innerWidth <= MOBILE_BREAKPOINT;
}

function ReportesView({
  enabled,
  isAdmin,
  locationsTableId,
  fieldConfig,
  attendanceUsersToDisplay,
  attendanceRecordsToDisplay,
  attendanceTemplateOptions,
  attendanceUserTemplates,
  defaultTemplateFile,
  asistenciasTableId,
  onRefresh,
  loadingAttendance,
  attendanceError,
  isUsingLiveAttendanceData
}) {
  const [isCompact, setIsCompact] = useState(getInitialCompactMode);
  const [showLocations, setShowLocations] = useState(() => !getInitialCompactMode());
  const [showReportBoard, setShowReportBoard] = useState(true);

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    const onResize = () => {
      const nextCompact = window.innerWidth <= MOBILE_BREAKPOINT;
      setIsCompact(nextCompact);
      if (!nextCompact) {
        setShowLocations(true);
        setShowReportBoard(true);
      }
    };
    onResize();
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return (
    <section className="reportes-view" data-ui-view="reportes" data-ui-section="reportes-view">
      <div className="reportes-view-toolbar" data-ui-section="reportes-toolbar">
        <button
          type="button"
          className={`pill ${showLocations ? 'active' : ''}`}
          onClick={() => setShowLocations(prev => !prev)}
        >
          {showLocations ? 'Ocultar ubicaciones' : 'Ubicaciones'}
        </button>
        <button
          type="button"
          className={`pill ${showReportBoard ? 'active' : ''}`}
          onClick={() => setShowReportBoard(prev => !prev)}
        >
          {showReportBoard ? 'Ocultar reportes' : 'Reportes'}
        </button>
      </div>

      {showLocations && (
        <AttendanceLocationsPanel
          enabled={enabled}
          isAdmin={isAdmin}
          locationsTableId={locationsTableId}
          fieldConfig={fieldConfig}
          defaultRadius={120}
        />
      )}

      {showReportBoard && (
        <AttendanceReportsBoard
          users={attendanceUsersToDisplay}
          records={attendanceRecordsToDisplay}
          templates={attendanceTemplateOptions}
          userTemplates={attendanceUserTemplates}
          defaultTemplateFile={defaultTemplateFile}
          asistenciasTableId={asistenciasTableId}
          onRefresh={onRefresh}
          loading={loadingAttendance}
          error={attendanceError}
          usingLiveData={isUsingLiveAttendanceData}
          compactMode={isCompact}
        />
      )}
    </section>
  );
}

export default ReportesView;
